import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../../img/icon.png';
import _imports_1 from '../../img/QRCode.png';
const _hoisted_1 = {
  class: "sevenpageButton"
};
const _hoisted_2 = {
  class: "topBox"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "nameList"
};
const _hoisted_5 = ["onClick"];
import { reactive, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { treeCatalogueSelectConfig } from "../../api/home";
export default {
  __name: 'navigationbarM',
  setup(__props) {
    const data = reactive({
      getMessageList: []
    });
    const route = useRoute();
    const router = useRouter();
    const detailedBtn = () => {
      localStorage.setItem("headId", 4);
      router.push({
        path: "/contactUs"
      });
    };

    // 查询基础信息
    const getMessageBtn = () => {
      treeCatalogueSelectConfig().then(res => {
        if (res && res.data) {
          data.getMessageList = res.data;
        }
        console.log(res);
      });
    };
    const clickItem = (index, id) => {
      localStorage.setItem("headId", index);
      localStorage.setItem("headValueId", id);
      if (id == '1987831222629982210') {
        router.push({
          path: "/"
        });
      } else if (id == '1988426439470223361') {
        router.push({
          path: "/AboutM"
        });
      } else {
        router.push({
          path: "/mediumM",
          query: {
            userId: id
          }
        });
      }
    };
    const clickBtn = (finalId, id) => {
      console.log(finalId, id, "77777");
      router.push({
        path: "/mediumM",
        query: {
          ids: id,
          userId: finalId
        }
      });
    };
    onMounted(() => {
      // 代码逻辑0
      getMessageBtn();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createStaticVNode("<div class=\"detailedBox\" data-v-c398afb2><div class=\"title\" data-v-c398afb2><img src=\"" + _imports_0 + "\" alt=\"\" data-v-c398afb2></div><div class=\"searchBoxOne\" data-v-c398afb2><img src=\"" + _imports_1 + "\" alt=\"\" data-v-c398afb2><div class=\"names\" data-v-c398afb2>协会官方微信</div></div></div>", 1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.getMessageList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "title",
          key: index
        }, [_createElementVNode("div", {
          class: "named",
          onClick: $event => clickItem(index, item.id)
        }, _toDisplayString(item.name), 9, _hoisted_3), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (items, indexs) => {
          return _openBlock(), _createElementBlock("div", {
            class: "name",
            key: indexs,
            onClick: $event => clickBtn(items.finalId, items.id)
          }, _toDisplayString(items.name), 9, _hoisted_5);
        }), 128))])]);
      }), 128))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "bottonBox"
      }, " 地址：浙江省杭州市滨江区六和路309号中控科技园E1705 电话：0571-86538535/86538511 传真：0571-86538500 ", -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "bottonBox"
      }, "(c)2025 版权所有：浙江省仪器仪表行业协会 浙ICP备05002928号-4 公安备案号：1925793824用597", -1))]);
    };
  }
};